import { converter } from '../../../masks/masks'
export default class Cte {
    constructor(chave, destCnpj, destIe, destNome, emissao, dtImportacao, emitCnpj, emitIe, emitNome, empresa, expedidorCnpj, expedidorIe,
        expedidorNome, nfe, numero, origem, recebCnpj, recebIe, recebNome, remetCnpj, remetIe, remetNome, status,
        tipo, tomadorCnpj, tomadorIe, tomadorNome, statusErp, valor, _id, customValues, danfe, manifestacao, modal, verProc, data_erp, departamento,log_statusErp,id_fluig,log_statusErpDois,statusErpDois) {


        this.emissao = new Date(emissao),
            this.numero = numero,
            this.remetNome = remetNome,
            this.valor = valor,
            this.remetIe = remetIe,
            this.remetCnpj = remetCnpj,
            this.chave = chave,
            this.destNome = destNome,
            this.destCnpj = destCnpj,
            this.destIe = destIe,
            this.origem = origem,
            this.status = status,
            this.tipo = tipo,
            this.tomadorCnpj = tomadorCnpj,
            this.tomadorNome = tomadorNome,
            this.tomadorIe = tomadorIe,
            this.emitCnpj = emitCnpj,
            this.emitNome = emitNome,
            this.emitIe = emitIe,
            this.expedidorCnpj = expedidorCnpj,
            this.expedidorNome = expedidorNome,
            this.expedidorIe = expedidorIe,
            this.recebCnpj = recebCnpj,
            this.recebNome = recebNome,
            this.recebIe = recebIe,
            this.dtImportacao = new Date(dtImportacao),
            this.vinculo = '',
            this.statusErp = statusErp,
            this.customValues = customValues,
            this.manifestacao = manifestacao,
            this.modal = modal,
            this.verProc = verProc,
            this.data_erp = converter(data_erp),
            this.departamento = departamento,
            this.id_fluig = id_fluig,
            this.log_statusErpDois = log_statusErpDois,
            this.statusErpDois= statusErpDois,
            this.log_statusErp= log_statusErp,
            this.danfe = danfe,
            this._id = _id,
            this.empresa = empresa,
            this.nfe = nfe,
            this.xml = ''

    }
}





// WEBPACK FOOTER //
// ./src/domain/notas/cte/Cte.js